
import {take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment} from '../../environments/environment'
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

import { UserProfileService } from './user-profile.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private userProfileService: UserProfileService, private router: Router) { }

  async canLoad(route: Route) {
    let okay=false;
    try
    {
      var rtn = this.userProfileService.IsUserLoggedIn().pipe(
          take(1))
          .toPromise();
        let xxs = await rtn;
        okay = xxs;
    }catch (error) {

    }

    // console.log("canload " + okay);

    if (okay) {
      return true;
    }
    let url = `/${route.path}`;
    this.router.navigate(['/login'], { queryParams: { redirectTo: url } });
    return this.userProfileService.isLoggedIn;
  }

async  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let okay=false;
    try
    {
      var rtn = this.userProfileService.IsUserLoggedIn().pipe(
          take(1))
          .toPromise();
        let xxs = await rtn;
        okay = xxs;
    }catch (error) {

    }


    if (okay) {
      return true;
    }
    this.router.navigate(['/login'], { queryParams: { redirectTo: state.url } });
    return false;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return this.canActivate(route, state);
  }
}

